{
  "gcp.api-key": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "displayName",
        "headerName": "Display Name"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "updateTime",
        "headerName": "Update Time"
      }
    ],
    "id": "name"
  },
  "gcp.app-engine": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      },
      {
        "type": "string",
        "field": "locationId",
        "headerName": "Location Id"
      },
      {
        "type": "string",
        "field": "servingStatus",
        "headerName": "Serving Status"
      },
      {
        "type": "string",
        "field": "authDomain",
        "headerName": "Auth Domain"
      },
      {
        "type": "string",
        "field": "defaultHostname",
        "headerName": "Default Hostname"
      }
    ],
    "id": "id"
  },
  "gcp.armor-policy": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      }
    ],
    "id": "name"
  },
  "gcp.autoscaler": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "target",
        "headerName": "Target"
      },
      {
        "type": "number",
        "field": "recommendedSize",
        "headerName": "Recommended Size"
      }
    ],
    "id": "name"
  },
  "gcp.bigtable-instance": {
    "columns": [
      {
        "type": "string",
        "field": "displayName",
        "headerName": "Display Name"
      }
    ],
    "id": "id"
  },
  "gcp.bq-dataset": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      },
      {
        "type": "string",
        "field": "friendlyName",
        "headerName": "Friendly Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "creationTime",
        "headerName": "Creation Time"
      },
      {
        "type": "string",
        "field": "lastModifiedTime",
        "headerName": "Last Modified Time"
      }
    ],
    "id": "id"
  },
  "gcp.bq-job": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      },
      {
        "type": "string",
        "field": "user_email",
        "headerName": "User_email"
      },
      {
        "type": "string",
        "field": "status.state",
        "headerName": "State"
      }
    ],
    "id": "id"
  },
  "gcp.bucket": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "timeCreated",
        "headerName": "Time Created"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      },
      {
        "type": "string",
        "field": "storageClass",
        "headerName": "Storage Class"
      }
    ],
    "id": "name"
  },
  "gcp.certmanager-certificate": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "expireTime",
        "headerName": "Expire Time"
      },
      {
        "type": "string",
        "field": "updateTime",
        "headerName": "Update Time"
      },
      {
        "type": "array",
        "field": "sanDnsnames",
        "headerName": "San Dnsnames"
      }
    ],
    "id": "name"
  },
  "gcp.cloud-run-job": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.name",
        "headerName": "Metadata"
      },
      {
        "type": "string",
        "field": "metadata.creationTimestamp",
        "headerName": "Creation Timestamp"
      }
    ],
    "id": "metadata.selfLink"
  },
  "gcp.cloud-run-revision": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.name",
        "headerName": "Metadata"
      },
      {
        "type": "string",
        "field": "metadata.creationTimestamp",
        "headerName": "Creation Timestamp"
      }
    ],
    "id": "metadata.selfLink"
  },
  "gcp.cloud-run-service": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.name",
        "headerName": "Metadata"
      },
      {
        "type": "string",
        "field": "metadata.creationTimestamp",
        "headerName": "Creation Timestamp"
      }
    ],
    "id": "metadata.selfLink"
  },
  "gcp.cloudbilling-account": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "displayName",
        "headerName": "Display Name"
      }
    ],
    "id": "name"
  },
  "gcp.compute-project": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "name"
  },
  "gcp.dataflow-job": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "currentState",
        "headerName": "Current State"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      }
    ],
    "id": "name"
  },
  "gcp.datafusion-instance": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "updateTime",
        "headerName": "Update Time"
      }
    ],
    "id": "name"
  },
  "gcp.disk": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "sizeGb",
        "headerName": "Size Gb"
      },
      {
        "type": "string",
        "field": "status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "zone",
        "headerName": "Zone"
      }
    ],
    "id": "name"
  },
  "gcp.dm-deployment": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "insertTime",
        "headerName": "Insert Time"
      },
      {
        "type": "string",
        "field": "updateTime",
        "headerName": "Update Time"
      }
    ],
    "id": "name"
  },
  "gcp.dns-managed-zone": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "dnsName",
        "headerName": "Dns Name"
      },
      {
        "type": "string",
        "field": "creationTime",
        "headerName": "Creation Time"
      },
      {
        "type": "string",
        "field": "visibility",
        "headerName": "Visibility"
      }
    ],
    "id": "id"
  },
  "gcp.dns-policy": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "boolean",
        "field": "enableLogging",
        "headerName": "Enable Logging"
      }
    ],
    "id": "id"
  },
  "gcp.firestore-database": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "locationId",
        "headerName": "Location Id"
      },
      {
        "type": "string",
        "field": "type",
        "headerName": "Type"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      }
    ],
    "id": "name"
  },
  "gcp.firewall": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "network",
        "headerName": "Network"
      },
      {
        "type": "number",
        "field": "priority",
        "headerName": "Priority"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "boolean",
        "field": "logConfig.enable",
        "headerName": "Enable"
      },
      {
        "type": "boolean",
        "field": "disabled",
        "headerName": "Disabled"
      }
    ],
    "id": "name"
  },
  "gcp.folder": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "displayName",
        "headerName": "Display Name"
      },
      {
        "type": "string",
        "field": "lifecycleState",
        "headerName": "Lifecycle State"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "parent",
        "headerName": "Parent"
      }
    ],
    "id": "name"
  },
  "gcp.function": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "runtime",
        "headerName": "Runtime"
      },
      {
        "type": "string",
        "field": "eventTrigger.eventType",
        "headerName": "Event Type"
      },
      {
        "type": "string",
        "field": "status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "updateTime",
        "headerName": "Update Time"
      }
    ],
    "id": "name"
  },
  "gcp.gke-cluster": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "currentMasterVersion",
        "headerName": "Current Master Version"
      },
      {
        "type": "string",
        "field": "currentNodeVersion",
        "headerName": "Current Node Version"
      },
      {
        "type": "number",
        "field": "currentNodeCount",
        "headerName": "Current Node Count"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      }
    ],
    "id": "name"
  },
  "gcp.iam-role": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "title",
        "headerName": "Title"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "stage",
        "headerName": "Stage"
      },
      {
        "type": "boolean",
        "field": "deleted",
        "headerName": "Deleted"
      }
    ],
    "id": "name"
  },
  "gcp.image": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "sourceType",
        "headerName": "Source Type"
      },
      {
        "type": "string",
        "field": "status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "string",
        "field": "diskSizeGb",
        "headerName": "Disk Size Gb"
      },
      {
        "type": "string",
        "field": "family",
        "headerName": "Family"
      }
    ],
    "id": "name"
  },
  "gcp.instance": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "string",
        "field": "machineType",
        "headerName": "Machine Type"
      },
      {
        "type": "string",
        "field": "zone",
        "headerName": "Zone"
      }
    ],
    "id": "name"
  },
  "gcp.instance-template": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "string",
        "field": "properties.machineType",
        "headerName": "Machine Type"
      },
      {
        "type": "string",
        "field": "properties.description",
        "headerName": "Description"
      }
    ],
    "id": "name"
  },
  "gcp.interconnect": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "string",
        "field": "operationalStatus",
        "headerName": "Operational Status"
      },
      {
        "type": "string",
        "field": "linkType",
        "headerName": "Link Type"
      },
      {
        "type": "string",
        "field": "location",
        "headerName": "Location"
      }
    ],
    "id": "name"
  },
  "gcp.interconnect-attachment": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "string",
        "field": "interconnect",
        "headerName": "Interconnect"
      },
      {
        "type": "string",
        "field": "router",
        "headerName": "Router"
      },
      {
        "type": "string",
        "field": "region",
        "headerName": "Region"
      },
      {
        "type": "string",
        "field": "operationalStatus",
        "headerName": "Operational Status"
      }
    ],
    "id": "name"
  },
  "gcp.kms-keyring": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      }
    ],
    "id": "name"
  },
  "gcp.kms-location": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "name"
  },
  "gcp.loadbalancer-address": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "address",
        "headerName": "Address"
      },
      {
        "type": "string",
        "field": "status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "region",
        "headerName": "Region"
      },
      {
        "type": "string",
        "field": "addressType",
        "headerName": "Address Type"
      }
    ],
    "id": "name"
  },
  "gcp.loadbalancer-backend-bucket": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "string",
        "field": "bucketName",
        "headerName": "Bucket Name"
      },
      {
        "type": "boolean",
        "field": "enableCdn",
        "headerName": "Enable Cdn"
      }
    ],
    "id": "name"
  },
  "gcp.loadbalancer-backend-service": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "string",
        "field": "region",
        "headerName": "Region"
      },
      {
        "type": "string",
        "field": "network",
        "headerName": "Network"
      }
    ],
    "id": "name"
  },
  "gcp.loadbalancer-forwarding-rule": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "region",
        "headerName": "Region"
      },
      {
        "type": "string",
        "field": "IPAddress",
        "headerName": "IP Address"
      },
      {
        "type": "string",
        "field": "IPProtocol",
        "headerName": "IP Protocol"
      },
      {
        "type": "string",
        "field": "target",
        "headerName": "Target"
      },
      {
        "type": "string",
        "field": "loadBalancingScheme",
        "headerName": "Load Balancing Scheme"
      },
      {
        "type": "string",
        "field": "serviceName",
        "headerName": "Service Name"
      },
      {
        "type": "string",
        "field": "network",
        "headerName": "Network"
      }
    ],
    "id": "name"
  },
  "gcp.loadbalancer-global-address": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "string",
        "field": "address",
        "headerName": "Address"
      },
      {
        "type": "string",
        "field": "region",
        "headerName": "Region"
      }
    ],
    "id": "name"
  },
  "gcp.loadbalancer-global-forwarding-rule": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "string",
        "field": "network",
        "headerName": "Network"
      },
      {
        "type": "string",
        "field": "networkTier",
        "headerName": "Network Tier"
      },
      {
        "type": "string",
        "field": "loadBalancingScheme",
        "headerName": "Load Balancing Scheme"
      },
      {
        "type": "string",
        "field": "subnetwork",
        "headerName": "Subnetwork"
      },
      {
        "type": "boolean",
        "field": "allowGlobalAccess",
        "headerName": "Allow Global Access"
      }
    ],
    "id": "name"
  },
  "gcp.loadbalancer-health-check": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "number",
        "field": "checkIntervalSec",
        "headerName": "Check Interval Sec"
      },
      {
        "type": "number",
        "field": "healthyThreshold",
        "headerName": "Healthy Threshold"
      },
      {
        "type": "number",
        "field": "unhealthyThreshold",
        "headerName": "Unhealthy Threshold"
      },
      {
        "type": "number",
        "field": "timeoutSec",
        "headerName": "Timeout Sec"
      }
    ],
    "id": "name"
  },
  "gcp.loadbalancer-http-health-check": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "host",
        "headerName": "Host"
      },
      {
        "type": "number",
        "field": "port",
        "headerName": "Port"
      },
      {
        "type": "string",
        "field": "requestPath",
        "headerName": "Request Path"
      },
      {
        "type": "number",
        "field": "checkIntervalSec",
        "headerName": "Check Interval Sec"
      }
    ],
    "id": "name"
  },
  "gcp.loadbalancer-https-health-check": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "host",
        "headerName": "Host"
      },
      {
        "type": "number",
        "field": "port",
        "headerName": "Port"
      },
      {
        "type": "string",
        "field": "requestPath",
        "headerName": "Request Path"
      },
      {
        "type": "number",
        "field": "checkIntervalSec",
        "headerName": "Check Interval Sec"
      }
    ],
    "id": "name"
  },
  "gcp.loadbalancer-ssl-certificate": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "string",
        "field": "type",
        "headerName": "Type"
      },
      {
        "type": "string",
        "field": "region",
        "headerName": "Region"
      },
      {
        "type": "string",
        "field": "expireTime",
        "headerName": "Expire Time"
      }
    ],
    "id": "name"
  },
  "gcp.loadbalancer-ssl-policy": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "profile",
        "headerName": "Profile"
      },
      {
        "type": "string",
        "field": "minTlsVersion",
        "headerName": "Min Tls Version"
      }
    ],
    "id": "name"
  },
  "gcp.loadbalancer-target-http-proxy": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "string",
        "field": "region",
        "headerName": "Region"
      },
      {
        "type": "string",
        "field": "urlMap",
        "headerName": "Url Map"
      }
    ],
    "id": "name"
  },
  "gcp.loadbalancer-target-https-proxy": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "string",
        "field": "sslPolicy",
        "headerName": "Ssl Policy"
      },
      {
        "type": "string",
        "field": "urlMap",
        "headerName": "Url Map"
      }
    ],
    "id": "name"
  },
  "gcp.loadbalancer-target-instance": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "string",
        "field": "zone",
        "headerName": "Zone"
      },
      {
        "type": "string",
        "field": "natPolicy",
        "headerName": "Nat Policy"
      },
      {
        "type": "string",
        "field": "instance",
        "headerName": "Instance"
      }
    ],
    "id": "name"
  },
  "gcp.loadbalancer-target-pool": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "region",
        "headerName": "Region"
      },
      {
        "type": "number",
        "field": "failoverRatio",
        "headerName": "Failover Ratio"
      },
      {
        "type": "string",
        "field": "sessionAffinity",
        "headerName": "Session Affinity"
      },
      {
        "type": "string",
        "field": "backupPool",
        "headerName": "Backup Pool"
      }
    ],
    "id": "name"
  },
  "gcp.loadbalancer-target-ssl-proxy": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "string",
        "field": "service",
        "headerName": "Service"
      },
      {
        "type": "string",
        "field": "sslPolicy",
        "headerName": "Ssl Policy"
      }
    ],
    "id": "name"
  },
  "gcp.loadbalancer-target-tcp-proxy": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "string",
        "field": "service",
        "headerName": "Service"
      }
    ],
    "id": "name"
  },
  "gcp.loadbalancer-url-map": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "string",
        "field": "region",
        "headerName": "Region"
      },
      {
        "type": "string",
        "field": "defaultService",
        "headerName": "Default Service"
      }
    ],
    "id": "name"
  },
  "gcp.log-exclusion": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      },
      {
        "type": "boolean",
        "field": "disabled",
        "headerName": "Disabled"
      },
      {
        "type": "string",
        "field": "filter",
        "headerName": "Filter"
      }
    ],
    "id": "name"
  },
  "gcp.log-project-metric": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "filter",
        "headerName": "Filter"
      }
    ],
    "id": "name"
  },
  "gcp.log-project-sink": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "destination",
        "headerName": "Destination"
      },
      {
        "type": "string",
        "field": "filter",
        "headerName": "Filter"
      },
      {
        "type": "string",
        "field": "writerIdentity",
        "headerName": "Writer Identity"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      }
    ],
    "id": "name"
  },
  "gcp.ml-job": {
    "columns": [
      {
        "type": "string",
        "field": "jobId",
        "headerName": "Job Id"
      },
      {
        "type": "string",
        "field": "state",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "endTime",
        "headerName": "End Time"
      }
    ],
    "id": "jobId"
  },
  "gcp.ml-model": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "boolean",
        "field": "onlinePredictionLogging",
        "headerName": "Online Prediction Logging"
      }
    ],
    "id": "name"
  },
  "gcp.ncc-spoke": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "state",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "hub",
        "headerName": "Hub"
      },
      {
        "type": "string",
        "field": "uniqueId",
        "headerName": "Unique Id"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      }
    ],
    "id": "name"
  },
  "gcp.notebook": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "state",
        "headerName": "State"
      }
    ],
    "id": "name"
  },
  "gcp.notebook-v2": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "state",
        "headerName": "State"
      }
    ],
    "id": "name"
  },
  "gcp.organization": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "displayName",
        "headerName": "Display Name"
      },
      {
        "type": "string",
        "field": "creationTime",
        "headerName": "Creation Time"
      },
      {
        "type": "string",
        "field": "lifecycleState",
        "headerName": "Lifecycle State"
      }
    ],
    "id": "name"
  },
  "gcp.patch-deployment": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "state",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "rollout.mode",
        "headerName": "Mode"
      }
    ],
    "id": "name"
  },
  "gcp.project": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "lifecycleState",
        "headerName": "Lifecycle State"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "parent.id",
        "headerName": "Id"
      }
    ],
    "id": "projectId"
  },
  "gcp.project-role": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "title",
        "headerName": "Title"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "stage",
        "headerName": "Stage"
      },
      {
        "type": "boolean",
        "field": "deleted",
        "headerName": "Deleted"
      }
    ],
    "id": "name"
  },
  "gcp.pubsub-snapshot": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "topic",
        "headerName": "Topic"
      },
      {
        "type": "string",
        "field": "expireTime",
        "headerName": "Expire Time"
      }
    ],
    "id": "name"
  },
  "gcp.pubsub-subscription": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "topic",
        "headerName": "Topic"
      },
      {
        "type": "number",
        "field": "ackDeadlineSeconds",
        "headerName": "Ack Deadline Seconds"
      },
      {
        "type": "boolean",
        "field": "retainAckedMessages",
        "headerName": "Retain Acked Messages"
      },
      {
        "type": "string",
        "field": "messageRetentionDuration",
        "headerName": "Message Retention Duration"
      }
    ],
    "id": "name"
  },
  "gcp.pubsub-topic": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "kmsKeyName",
        "headerName": "Kms Key Name"
      }
    ],
    "id": "name"
  },
  "gcp.redis": {
    "columns": [
      {
        "type": "string",
        "field": "displayName",
        "headerName": "Display Name"
      }
    ],
    "id": "name"
  },
  "gcp.redis-cluster": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "state",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      }
    ],
    "id": "name"
  },
  "gcp.region-commitment": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "type",
        "headerName": "Type"
      },
      {
        "type": "string",
        "field": "plan",
        "headerName": "Plan"
      },
      {
        "type": "string",
        "field": "category",
        "headerName": "Category"
      },
      {
        "type": "string",
        "field": "region",
        "headerName": "Region"
      },
      {
        "type": "string",
        "field": "endTimestamp",
        "headerName": "End Timestamp"
      }
    ],
    "id": "name"
  },
  "gcp.route": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "string",
        "field": "network",
        "headerName": "Network"
      },
      {
        "type": "number",
        "field": "priority",
        "headerName": "Priority"
      },
      {
        "type": "string",
        "field": "destRange",
        "headerName": "Dest Range"
      }
    ],
    "id": "name"
  },
  "gcp.router": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "string",
        "field": "region",
        "headerName": "Region"
      },
      {
        "type": "string",
        "field": "network",
        "headerName": "Network"
      }
    ],
    "id": "name"
  },
  "gcp.secret": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "expireTime",
        "headerName": "Expire Time"
      },
      {
        "type": "string",
        "field": "ttl",
        "headerName": "Ttl"
      }
    ],
    "id": "name"
  },
  "gcp.service": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "state",
        "headerName": "State"
      }
    ],
    "id": "name"
  },
  "gcp.service-account": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "displayName",
        "headerName": "Display Name"
      },
      {
        "type": "string",
        "field": "email",
        "headerName": "Email"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "boolean",
        "field": "disabled",
        "headerName": "Disabled"
      }
    ],
    "id": "name"
  },
  "gcp.snapshot": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "diskSizeGb",
        "headerName": "Disk Size Gb"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      }
    ],
    "id": "name"
  },
  "gcp.sourcerepo": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "size",
        "headerName": "Size"
      },
      {
        "type": "string",
        "field": "url",
        "headerName": "Url"
      }
    ],
    "id": "name"
  },
  "gcp.spanner-instance": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "displayName",
        "headerName": "Display Name"
      },
      {
        "type": "number",
        "field": "nodeCount",
        "headerName": "Node Count"
      },
      {
        "type": "string",
        "field": "state",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "config",
        "headerName": "Config"
      }
    ],
    "id": "name"
  },
  "gcp.sql-instance": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "state",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "databaseVersion",
        "headerName": "Database Version"
      },
      {
        "type": "string",
        "field": "settings.tier",
        "headerName": "Tier"
      },
      {
        "type": "string",
        "field": "settings.dataDiskSizeGb",
        "headerName": "Data Disk Size Gb"
      }
    ],
    "id": "name"
  },
  "gcp.subnet": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "string",
        "field": "ipCidrRange",
        "headerName": "Ip Cidr Range"
      },
      {
        "type": "string",
        "field": "gatewayAddress",
        "headerName": "Gateway Address"
      },
      {
        "type": "string",
        "field": "region",
        "headerName": "Region"
      },
      {
        "type": "string",
        "field": "state",
        "headerName": "State"
      }
    ],
    "id": "name"
  },
  "gcp.vertex-ai-batch-prediction-job": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "displayName",
        "headerName": "Display Name"
      },
      {
        "type": "string",
        "field": "state",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "updateTime",
        "headerName": "Update Time"
      }
    ],
    "id": "name"
  },
  "gcp.vertex-ai-custom-job": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "displayName",
        "headerName": "Display Name"
      },
      {
        "type": "string",
        "field": "state",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "updateTime",
        "headerName": "Update Time"
      }
    ],
    "id": "name"
  },
  "gcp.vertex-ai-dataset": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "displayName",
        "headerName": "Display Name"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "updateTime",
        "headerName": "Update Time"
      },
      {
        "type": "string",
        "field": "metadataSchemaUri",
        "headerName": "Metadata Schema Uri"
      }
    ],
    "id": "name"
  },
  "gcp.vertex-ai-endpoint": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "displayName",
        "headerName": "Display Name"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "updateTime",
        "headerName": "Update Time"
      }
    ],
    "id": "name"
  },
  "gcp.vertex-ai-hyperparameter-tuning-job": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "displayName",
        "headerName": "Display Name"
      },
      {
        "type": "string",
        "field": "state",
        "headerName": "State"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "updateTime",
        "headerName": "Update Time"
      },
      {
        "type": "number",
        "field": "parallelTrialCount",
        "headerName": "Parallel Trial Count"
      },
      {
        "type": "number",
        "field": "maxTrialCount",
        "headerName": "Max Trial Count"
      }
    ],
    "id": "name"
  },
  "gcp.vertex-ai-model": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "displayName",
        "headerName": "Display Name"
      },
      {
        "type": "string",
        "field": "trainingPipeline",
        "headerName": "Training Pipeline"
      },
      {
        "type": "string",
        "field": "createTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "updateTime",
        "headerName": "Update Time"
      }
    ],
    "id": "name"
  },
  "gcp.vpc": {
    "columns": [
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "description",
        "headerName": "Description"
      },
      {
        "type": "string",
        "field": "creationTimestamp",
        "headerName": "Creation Timestamp"
      },
      {
        "type": "boolean",
        "field": "autoCreateSubnetworks",
        "headerName": "Auto Create Subnetworks"
      },
      {
        "type": "string",
        "field": "IPv4Range",
        "headerName": "I Pv4 Range"
      },
      {
        "type": "string",
        "field": "gatewayIPv4",
        "headerName": "Gateway I Pv4"
      }
    ],
    "id": "name"
  },
  "gcp.zone": {
    "columns": [
      {
        "type": "string",
        "field": "id",
        "headerName": "Id"
      },
      {
        "type": "string",
        "field": "name",
        "headerName": "Name"
      }
    ],
    "id": "name"
  }
}
